import React, { useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import {
	FileGroup,
	TextAreaField,
	// SelectFieldStatus
} from "../../../components/Form/FormComponents";
import ActionSideBar from "../partials/ActionSideBar";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import { LeaseeInformation, LeasorInformation, RequestInformationLease } from "../partials/FormFieldsLease";
import { RequestInformationAF } from "../partials/FormFieldsAF";

// eslint-disable-next-line no-unused-vars
const ReassignedForm = ({ requestData, setRequestData, filter }) => {
	const [formData, setFormData] = useState(requestData);
	const [action, setAction] = useState("view");
	const isEditable = action === "edit";
	const isLeasing = filter === "lease";

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	// eslint-disable-next-line no-unused-vars
	const handleCancel = () => {
		setFormData(requestData);
		setAction("view");
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		console.log(formData);
		setRequestData(formData);
		// updateCurrentObject(formData);
	};

	return (
		<>
			<StyledForm onSubmit={handleSubmit}>
				<ActionSideBar
					requestData={formData}
					// action={action}
					// setAction={setAction}
					// handleCancel={handleCancel}
					canEditStatus={true}
				/>

				<div className='RightSection'>
					<FormAccordion title='Request Information' open={true}>
						<div className='grid grid-cols-3 gap-3'>
							{isLeasing ? (
								<RequestInformationLease
									formData={formData}
									isEditable={isEditable}
									handleInputChange={handleInputChange}
									except={["approvalStatus", "disbursement"]}
								/>
							) : (
								<RequestInformationAF
									formData={formData}
									isEditable={isEditable}
									handleInputChange={handleInputChange}
									except={["approvalStatus", "disbursement"]}
								/>
							)}
						</div>
					</FormAccordion>
					{isLeasing ? (
						<>
							<FormAccordion title='Product description'>
								<div className='form-group'>
									<TextAreaField
										name='product_desc'
										value={formData?.description || formData?.productId?.description}
									/>
								</div>
							</FormAccordion>

							<FormAccordion title='Key features'>
								<div className='form-group'>
									<TextAreaField
										name='keyFeatures'
										value={formData?.keyFeatures && formData?.keyFeatures?.replace(/;/g, "<br/>")}
									/>
								</div>
							</FormAccordion>

							<FormAccordion title='Product specifications'>
								<div className='form-group'>
									<TextAreaField
										name='specifications'
										value={formData?.specifications && formData?.specifications?.replace(/;/g, "<br/>")}
									/>
								</div>
							</FormAccordion>

							<FormAccordion title='Leasor’s Information'>
								<LeasorInformation formData={formData} />
							</FormAccordion>

							<FormAccordion title='Leasee’s Information'>
								<LeaseeInformation formData={formData} />
							</FormAccordion>
						</>
					) : (
						<>
							<FormAccordion title='Proof of purchase'>
								<div className='form-group'>
									<FileGroup value={formData?.proofOfPurchaseDoc?.url} />
								</div>
							</FormAccordion>
						</>
					)}
				</div>
			</StyledForm>
		</>
	);
};

// Props Validation
ReassignedForm.propTypes = {
	requestData: PropTypes.object,
	setRequestData: PropTypes.func,
	filter: PropTypes.string,
	// updateCurrentObject: PropTypes.func,
};

export default ReassignedForm;
